$(function () {
    $(".hero-carousel-block .hero-carousel-block__slides-container").slick({
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        variableWidth: false,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 1500,
        pauseOnFocus: true,
        pauseOnHover: true,
        cssEase: 'ease-in-out',
        easing: 'swing',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: false,
                    dots: true,
                    speed: 500
               }
            }
        ]
    });
});